<template>
  <v-navigation-drawer
    app
    permanent
    left
    width="512"
    style="background-color: #2f6e7c"
    :mini-variant-width="100"
    expand-on-hover
    :mini-variant.sync="isMini"
  >
    <div class="d-flex flex-column justify-space-between fill-height">
      <v-container>
        <v-row align="center">
          <!-- <v-col cols="12" class="d-flex justify-center">
            <v-btn @click="$router.push(`/`)" v-if="!isMini" color="blue-grey" class="white--text" style="width: 100%">
              <v-icon left dark>mdi-keyboard-return</v-icon>Dialogs
            </v-btn>
          </v-col> -->
          <!-- <v-col cols="12" class="d-flex justify-center">
            <v-btn
              :to="`/history/${$route.params.id}`"
              target="_blank"
              v-if="!isMini"
              color="blue-grey"
              class="white--text"
              style="width:100%"
            >
              <v-icon left dark>mdi-history</v-icon>History
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-btn
              :to="`/history/${$route.params.id}/error`"
              target="_blank"
              v-if="!isMini"
              color="blue-grey"
              class="white--text"
              style="width:100%"
            >
              <v-icon left dark>mdi-history</v-icon>Errors
            </v-btn>
          </v-col> -->
          <!-- <v-col cols="12" class="d-flex justify-center">
            <v-btn
              :to="`/project/${$route.params.id}/chat`"
              target="_blank"
              v-if="!isMini"
              color="blue-grey"
              class="white--text"
              style="width: 100%"
            >
              <v-icon left dark>mdi-chat</v-icon>Chat
            </v-btn>
          </v-col> -->
          <v-col cols="8" class="d-flex flex-column align-center px-12">
            <h1 class="mt-4 mb-2 white--text text-h3 text-center">Stories</h1>
          </v-col>
          <v-col cols="4" class="d-flex justify-space-around">
            <v-btn
              v-if="!isMini"
              @click="
                vikyModal = true;
                vikyToken = project.viky.token;
                slug = project.viky.slug;
                fallback = project.fallback;
              "
              color="white"
              x-large
              text
            >
              <v-icon>mdi-cog-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-toolbar v-if="!isMini" dark class="head-context">
          <v-toolbar-title>
            <v-icon
              left
              dark
              icon
              @click="$router.push(`/`)"
              v-if="!isMini"
              title="Back to dialogs"
            >
              mdi-subdirectory-arrow-left
            </v-icon>
            <strong>{{ projectName }}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            :to="`/project/${$route.params.id}/chat`"
            target="_blank"
            v-if="!isMini"
            title="Go to chat"
          >
            <v-icon dark>mdi-chat</v-icon>
          </v-btn>
        </v-toolbar>

        <div
          class="skills"
          :style="{
            'max-height': 'calc(100vh - 300px)',
            'overflow-y': !isMini ? 'scroll' : 'visible',
            'overflow-x': 'hidden',
          }"
        >
          <v-list
            v-for="(skill, index) in skills"
            :key="`links-${index}`"
            class="d-flex align-center"
          >
            <v-list-item
              @click="openSkill(skill)"
              class="mt-2"
              @mouseenter="showButtons(index)"
              @mouseleave="hideButtons(index)"
            >
              <v-list-item-icon v-if="$route.params.skillId === skill._id">
                <v-icon color="dark" :medium="isMini">mdi-check</v-icon>
              </v-list-item-icon>

              <v-list-item-content class="white--text">
                <v-list-item-title
                  class="body-1 text-capitalize"
                  style="width: 10px; overflow: hidden"
                >
                  {{ skill.name }}
                </v-list-item-title>
              </v-list-item-content>
              <v-btn icon disabled v-if="skill.isStart" color="white">
                <v-icon>mdi-location-enter</v-icon>
              </v-btn>
              <v-btn
                v-if="!isMini"
                icon
                text
                color="white"
                title="Delete story"
                class="hide"
                :class="`skill-${index}`"
                @click.stop.prevent="removeSkill(skill)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn
                v-if="!isMini"
                icon
                text
                color="white"
                title="Edit story"
                class="hide"
                :class="`skill-${index}`"
                @click.stop.prevent="
                  editDialog = true;
                  currentSkill = skill;
                "
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
                            <v-btn
                v-if="!isMini"
                icon
                text
                color="white"
                title="Duplicate story"
                class="hide"
                :class="`skill-${index}`"
                @click.stop.prevent="duplicateSkill(index)"
              >
                <v-icon>mdi-content-duplicate</v-icon>
              </v-btn>
              <v-btn
                v-if="!isMini"
                icon
                text
                color="white"
                title="Download all messages"
                class="hide"
                :class="`skill-${index}`"
                @click.stop.prevent="downloadMessages(skill, projectName)"
              >
                <v-icon>mdi-file-download-outline</v-icon>
              </v-btn>
            </v-list-item>
          </v-list>
        </div>

        <v-row align="center" style="position: absolute; bottom: 0px">
          <v-col cols="12">
            <v-text-field
              v-if="!isMini"
              v-model="skillName"
              style="width: 480px"
              color="white"
              @keyup.enter="addSkill"
              dark
              placeholder="Story Name"
            >
              <template v-slot:append-outer>
                <v-btn icon text color="white" @click="addSkill">
                  <v-icon large>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-dialog v-model="editDialog" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Story</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Story Name"
            v-model="currentSkill.name"
          ></v-text-field>
          <v-switch
            v-model="currentSkill.isStart"
            label="Start Story"
          ></v-switch>
          <v-switch
            v-model="currentSkill.isLatent"
            label="Latent Dialogue"
          ></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editDialog = false"
            >Close</v-btn
          >
          <v-btn color="blue darken-1" text @click="editSkill">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vikyModal" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Dialog</span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Viky Token" v-model="vikyToken"></v-text-field>
          <v-text-field label="Viky Slug" v-model="slug"></v-text-field>
          <v-text-field
            label="Fallback Message"
            v-model="fallback"
          ></v-text-field>
          <v-row>
            <v-col>
              <v-btn
                style="width: 100%"
                color="success"
                @click="exportBot()"
                dark
              >
                Export
                <v-icon right dark>mdi-application-export</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="vikyModal = false"
            >Close</v-btn
          >
          <v-btn color="blue darken-1" text @click="editProject">update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";
import dateFomrat from "dateformat";
export default {
  data() {
    return {
      vikyModal: false,
      isMini: true,
      skillName: "",
      skills: [],
      currentSkill: {},
      editDialog: false,
      project: {},
      vikyToken: "",
      slug: "",
      fallback: "",
      projectName: "",
    };
  },

  methods: {
    ...mapActions({
      getNodes: "http/nodes/getNodes",
    }),
    showButtons(index) {
      const domId = `skill-${index}`;
      const buttons = document.getElementsByClassName(domId);
      buttons.forEach((button) => button.classList.remove("hide"));
    },
    hideButtons(index) {
      const domId = `skill-${index}`;
      const buttons = document.getElementsByClassName(domId);
      buttons.forEach((button) => button.classList.add("hide"));
    },
    async downloadMessages(skill, projectName) {
      const nodes = await this.getNodes(skill._id);
      const actions = nodes.map((x) => x.actions);
      const allMessages = [];

      for (let action of actions) {
        const tmp = action.filter((x) => x.actionType === "message");
        if (tmp.length) {
          allMessages.push(tmp[0].args[0]);
        }
      }
      const date = dateFomrat(new Date(), "dd-mm-yyyy");
      allMessages.forEach(
        (element, index) => (allMessages[index] = "¬ " + element.trim())
      );
      if (allMessages.length) {
        this.download(
          `[${projectName}][${skill.name}]_Messages_${date}.txt`,
          allMessages.join("\n")
        );
      } else {
        this.$fire({
          title: "Oops.. Empty skill",
          text: "This skill has no messages",
          type: "error",
          timer: 3000,
        });
      }
    },
    openSkill(skill) {
      if (this.$route.params.skillId !== skill._id) {
        localStorage.removeItem("panzoom_position");
        this.skillId = this.$route.params.skillId;
        this.$router.push(
          `/projects/${this.$route.params.id}/skills/${skill._id}`
        );
        location.reload();
      }
    },
    getProject() {
      return this.$http
        .get(`/projects/${this.$route.params.id}`)
        .then(({ data }) => {
          this.project = data;
          this.projectName = data.name;
        });
    },
    download(filename, text) {
      const element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    exportBot() {
      return this.$http
        .get(`/projects/export/${this.$route.params.id}`)
        .then(({ data }) => {
          const projectName = data?.project?.name;
          const currentDate = this.formatDateToDDMMYYYY(new Date());
          this.download(
            `${projectName}-${currentDate}.json`,
            JSON.stringify(data)
          );
        });
    },

    getSkills() {
      return this.$http
        .get(`/projects/${this.$route.params.id}/skills/`)
        .then(({ data }) => {
          this.skills = data.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
          );
        });
    },
    addSkill() {
      if (this.skillName?.length > 0) {
        this.$http
          .post(`/projects/${this.$route.params.id}/skills`, {
            name: this.skillName,
          })
          .then(() => {
            this.getSkills().then(() => {
              this.skillName = "";
            });
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
      }
    },
    async duplicateSkill(index) {
      let newSkillName = this.skills[index]?.name + '-COPY' || '';
      await this.$http
          .post(`/projects/${this.$route.params.id}/skills/duplicate`, {
            name: newSkillName,
            skillId: this.skills[index]?._id
          })
          .then((data) => {
            let skill = data?.data
            this.skills.push(skill);
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
    },
    editSkill() {
      if (this.currentSkill?._id) {
        this.$http
          .put(
            `/projects/${this.$route.params.id}/skills/${this.currentSkill._id}`,
            {
              name: this.currentSkill.name,
              isStart: this.currentSkill.isStart,
              isLatent: this.currentSkill.isLatent,
            }
          )
          .then(() => {
            this.getSkills().then(() => {
              this.editDialog = false;
              this.currentSkill = {};
            });
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
      }
    },
    editProject() {
      this.project.viky.token = this.vikyToken;
      this.project.viky.slug = this.slug;
      this.project.fallback = this.fallback;
      this.$http
        .put(`/projects/${this.$route.params.id}`, this.project)
        .then(() => {
          this.getProject().then(() => {
            this.vikyModal = false;
            this.vikyToken = "";
            this.slug = "";
            this.fallback = "";
          });
        })
        .catch((err) => {
          this.$notify({ type: "error", text: err.response.data.message });
        });
    },
    removeSkill(skill) {
      this.$confirm(
        `Are you sure you want to delete the skill <strong>${skill.name}</strong> ?`
      ).then((res) => {
        if (res) {
          this.$http
            .delete(`/projects/${this.$route.params.id}/skills/${skill._id}`)
            .then(() => {
              this.getSkills().then(() => {
                if (
                  this.$route.params.skillId === skill._id &&
                  this.skills[0]._id
                ) {
                  this.$router.push(
                    `/projects/${this.$route.params.id}/skills/${this.skills[0]._id}`
                  );
                }
              });
            })
            .catch((err) => {
              this.$notify({ type: "error", text: err.response.data.message });
            });
        }
      });
    },
    formatDateToDDMMYYYY(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },

  beforeMount() {
    this.getSkills();
    this.getProject();
  },
};
</script>

<style scoped>
.avatar-profil-container {
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.skills::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #2f6e7c;
}

.skills::-webkit-scrollbar {
  width: 5px;
  background-color: #2f6e7c;
}

.skills::-webkit-scrollbar-thumb {
  background-color: #ffffff;
}

.head-context {
  border-radius: 10px 10px 0px 10px;
  height: 5%;
}
.encadre {
  box-shadow: 0 0 1px 0px black;
}

.hide {
  visibility: collapse;
}
</style>
